export const SheetPositionPicker = ({ cols, rows, value, onChange }) => {
  if (!cols || !rows) return null;
  const cells = Array.from({ length: cols * rows }, (_, i) => i + 1);
  return (
    <div className="space-y-2" data-testid="labels-start-picker">
      <div className="mx-auto max-w-[200px] rounded-md border border-border bg-white/95 p-1.5 grid gap-1" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)`, aspectRatio: "8.5 / 11" }}>
        {cells.map((n) => (
          <button key={n} type="button" onClick={() => onChange(n)} title={`Start at label ${n}`} data-testid={`labels-start-cell-${n}`}
            className={`rounded-[3px] text-[10px] font-semibold leading-none transition-colors duration-150 ${n < value ? "bg-slate-300 text-slate-600 line-through" : n === value ? "bg-primary text-primary-foreground ring-2 ring-primary/40" : "bg-slate-100 text-slate-700 hover:bg-primary/25"}`}>
            {n}
          </button>
        ))}
      </div>
      <p className="text-xs text-muted-foreground text-center" data-testid="labels-start-summary">
        {value === 1 ? "Starting at the first label (full sheet)." : `Starting at label ${value} \u2014 skipping ${value - 1} used label${value === 2 ? "" : "s"}.`}
      </p>
    </div>
  );
};
